<ul class="list-unstyled alert alert-danger fadeIn"><li class="small" *ngFor="let e of errors"><i class="lnr lnr-cross me-2"></i>{{ e.detail }}</li></ul>